{
  "projectAttributes": {
    "title": "Attributeinstellungen",
    "subtitle": "Hier können Sie vordefinierte Attribute hinzufügen und löschen, die Ihre Projektbenutzer anzeigen und verwenden können.",
    "predefined_title": "Vordefinierte Attribute",
    "predefined_text": "Passen Sie die vordefinierten Attribute Ihres Projekts an, die zu Planebenen hinzugefügt werden können.",
    "no_attributes": "Es gibt keine Projektattribute. Erstellen Sie eines, indem Sie oben auf die Schaltfläche „Attribut hinzufügen“ klicken",
    "active_tab": "Aktiv",
    "deprecated_tab": "Inaktiv",
    "no_deprecated_attributes": "Es gibt keine inaktiven Projektattribute",
    "deprecate_confirmation_title": "Attribut deaktivieren?",
    "deprecate_confirmation_message": "Dieses Attribut wird verwendet und kann nicht gelöscht werden. Es wird stattdessen deaktiviert. Inaktive Attribute werden beim Hinzufügen von Attributen zu Ebenen ausgeblendet, verbleiben aber auf Ebenen, denen sie bereits hinzugefügt wurden.",
    "delete_confirmation_title": "Attribut löschen?",
    "delete_confirmation_message": "Möchten Sie dieses Attribut wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "restore_button": "Wiederherstellen"
  }
}